"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ColorPicker: function() {
        return ColorPicker;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ColorPicker = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M20.2929 3.7071C19.5789 2.99306 18.4212 2.99306 17.7071 3.7071L14.9142 6.5L17.5 9.08578L20.2929 6.29289C21.007 5.57884 21.007 4.42115 20.2929 3.7071ZM18.9142 10.5L21.7071 7.7071C23.2022 6.21201 23.2022 3.78798 21.7071 2.29289C20.212 0.797796 17.788 0.797797 16.2929 2.29289L13.5 5.08578L12.7071 4.29289C12.3166 3.90237 11.6834 3.90237 11.2929 4.29289C10.9024 4.68341 10.9024 5.31658 11.2929 5.7071L12.0858 6.5L4.1716 14.4142C3.42146 15.1644 3.00003 16.1818 3.00003 17.2426V17.7639L1.1056 21.5528C0.913106 21.9378 0.98856 22.4027 1.29292 22.7071C1.59728 23.0115 2.06225 23.0869 2.44724 22.8944L6.23609 21H6.75739C7.81825 21 8.83567 20.5786 9.58582 19.8284L17.5 11.9142L18.2929 12.7071C18.6834 13.0976 19.3166 13.0976 19.7071 12.7071C20.0977 12.3166 20.0977 11.6834 19.7071 11.2929L18.9142 10.5ZM16.0858 10.5L13.5 7.91421L5.58582 15.8284C5.21074 16.2035 5.00003 16.7122 5.00003 17.2426V18C5.00003 18.1552 4.96388 18.3084 4.89445 18.4472L4.2361 19.7639L5.55281 19.1056C5.69167 19.0361 5.84478 19 6.00003 19H6.75739C7.28782 19 7.79653 18.7893 8.1716 18.4142L16.0858 10.5Z",
        fill: "currentColor"
    })
}), "ColorPicker");
const _default = ColorPicker;
